import { render, staticRenderFns } from "./WidgetCoin.vue?vue&type=template&id=4f939e47&"
import script from "./WidgetCoin.vue?vue&type=script&lang=ts&"
export * from "./WidgetCoin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports